//User
export const USER_LOGIN = 'USER_LOGIN';
export const USER_CREATE = 'USER_CREATE';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_DELETE = 'USER_DELETE';
export const USER_GET_ALL = 'USER_GET_ALL';
export const USER_LOAD_IMAGE_PROFILE = 'USER_LOAD_IMAGE_PROFILE';
export const USER_UPDATE_REDUX = 'USER_UPDATE_REDUX';
export const USER_GET_BY_INSURANCE = 'USER_GET_BY_INSURANCE';

//Auth
export const GET_TOKEN_API = "GET_TOKEN_API"

//Customer
export const CUSTOMER_CREATE = 'USER_CREATE';
export const CUSTOMER_UPDATE = 'USER_UPDATE';
export const CUSTOMER_DELETE = 'USER_DELETE';
export const CUSTOMER_GET_ALL = 'USER_GET_ALL';

//Customer
export const SUSCRIPTION_CREATE =  'SUSCRIPTION_CREATE';
export const SUSCRIPTION_UPDATE =  'SUSCRIPTION_UPDATE';
export const SUSCRIPTION_DELETE =  'SUSCRIPTION_DELETE';
export const SUSCRIPTION_GET_ALL = 'SUSCRIPTION_GET_ALL';
export const SUSCRIPTION_GET = 'SUSCRIPTION_GET';



